import { render, staticRenderFns } from "./ActionsByTypesActionChart.vue?vue&type=template&id=12518be4&"
import script from "./ActionsByTypesActionChart.vue?vue&type=script&lang=ts&"
export * from "./ActionsByTypesActionChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports